import { ClearOutlined, Search } from '@mui/icons-material';
import { Box, IconButton, InputAdornment, TextField } from '@mui/material';
import _ from 'lodash';
import React, { useEffect } from 'react';

interface IProps {
  defaultValue?: string | null;
  onSearch: (value: string) => void;
  updateValue?: (value: string) => void;
  onChange?: (value: string) => void; // this callback is throttled and will only call once the user is done typing
  clearInput?: number; // simply increment to clear
  showClearIcon?: boolean; // show clear icon
  handleOnClear?: () => void; // clear input callback
  treeComponent?: React.ReactNode; // 👈 Tree dropdown
  selectedCount?: number;
}

export const FuelSearchInput = ({
  defaultValue = null,
  onSearch,
  updateValue,
  onChange,
  clearInput = 0,
  showClearIcon = false,
  handleOnClear,
  treeComponent = null,
  selectedCount = 0,
}: IProps) => {
  const inputRef = React.useRef(null);
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      doSearch(e);
    }
  };

  useEffect(() => {
    // console.log('clearInput changed', { defaultValue });
    if (clearInput > 0) {
      setInputValue('');
    }
  }, [clearInput]);

  // useEffect(() => {
  //   // console.log('FuelSearchInput init', { defaultValue });
  //   setInputValue(defaultValue);
  // }, []);

  const setInputValue = (value) => {
    const input: HTMLElement | null = inputRef.current;
    if (input) {
      const inputInners = input.getElementsByTagName('input');
      if (inputInners && inputInners.length > 0) {
        inputInners[0].value = defaultValue;
      }
    }
  };

  const getInputElement = () => {
    const input: HTMLElement | null = inputRef.current;
    if (input) {
      const inputInners = input.getElementsByTagName('input');
      if (inputInners && inputInners.length > 0) {
        return inputInners[0];
      }
    }
  };

  const handleClick = (e) => {
    doSearch(e);
  };

  const doSearch = (e) => {
    // console.log('doSearch');
    const input: HTMLElement | null = inputRef.current;
    if (input) {
      const inputInners = input.getElementsByTagName('input');
      if (inputInners && inputInners.length > 0) {
        let val = inputInners[0].value;
        if (val) val = val.trim();
        inputInners[0].value = val;
        // console.log('doSearch', `'${val}'`);
        if (onSearch) onSearch(val);
      }
    }
  };

  const throttledCallback = _.debounce(function (value) {
    // console.log('InputSearch throttled callback', { value });
    if (onChange) {
      onChange(value);
    }
  }, 300);

  const onTextChanged = (e) => {
    const { value } = e.target;
    // console.log('onTextChanged', { value });

    if (updateValue) {
      updateValue(value);
    }
    throttledCallback(value);
  };

  const onSearchBlur = (evt) => {
    // console.log('onSearchBlur');
    let searchText = evt.target.value;
    // console.log('onSearchBlur', searchText);
    if (searchText) {
      searchText = searchText.trim();
      evt.target.value = searchText;
    }
    if (updateValue) updateValue(searchText);
  };

  const onClear = (evt) => {
    // console.log('onClear', { value });
    const input = getInputElement();
    if (input) {
      input.value = '';
      if (onChange) {
        onChange('');
      }
      if (updateValue) {
        updateValue('');
      }
      handleOnClear?.();
    }
  };

  return (
    <div className="fuel-search-input">
      <TextField
        ref={inputRef}
        label="Search"
        fullWidth
        size="small"
        onChange={onTextChanged}
        onKeyDown={handleKeyDown}
        placeholder="Keyword"
        defaultValue={defaultValue}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end" sx={{ mr: 4 }}>
              <Box
                className="fuel-search-input__tree-divider"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  pl: 1,
                  ml: 1,
                }}
              >
                {treeComponent}
              </Box>
            </InputAdornment>
          ),
          maxLength: 250,
          onBlur: onSearchBlur,
        }}
      />

      {showClearIcon && (
        <div className="clear-button" title="Clear Search Keyword">
          {/* <span onClick={onClear}>x</span> */}
          <IconButton onClick={onClear} className="clear-icon">
            <ClearOutlined />
          </IconButton>
        </div>
      )}
      <IconButton onClick={handleClick} className="search-button" title="Search">
        <Search />
      </IconButton>
    </div>
  );
};

export default FuelSearchInput;
